/* eslint-disable no-shadow */
const state = {
  categories: Array
};

const getters = {
  getCategoryData: state => state.categories
};

const mutations = {
  setCategoryMutation: (state, payload) => {
    state.categories = payload;
  }
};

const actions = {
  setCategory: ({ commit }, payload) => {
    commit("setCategoryMutation", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
